<div class="layout">
  <ng-container *ngIf="showMenu === 'both'">
    <mfp-menu
      class="layout__menu"
      [onlyLifePlanNavigation]="true"
    ></mfp-menu>
  </ng-container>
  <div class="layout__page">
    <mfp-header
      *ngIf="showHeader"
      id="layoutHeader"
      [showMenu]="showMenu === 'header' || showMenu === 'both'"
      [border]="headerBorder"
    ></mfp-header>
    <div
      mfpScrollContainer
      id="layoutScrollContainer"
      class="layout__scroll-container"
      [ngStyle]="{ 'background-image': 'url(' + backgroundImage + ')' }"
    >
      <div
        class="layout__container"
      >
        <div
          class="layout__content"
          [ngClass]="{'layout__content--center': contentCentered, 'layout__content--padding': contentPadding}"
        >
          <ng-content></ng-content>
        </div>
        <ng-container *ngIf="showFooter">
          <mfp-footer></mfp-footer>
        </ng-container>
      </div>
    </div>
  </div>
</div>
